/**
 * Ordered identifiers for the tutorial screens. The order here is the order the
 * screens appear in (and maps to the `/game/help/:screenIndex` route index).
 *
 * Each id has matching translation keys at `help.screens.<id>.title` and
 * `help.screens.<id>.instruction`. Both HelpSection (the tutorial itself) and
 * AppMenu (the help screen list) read titles from these ids, so the labels stay
 * in sync and localised from a single source.
 */
export const HELP_SCREEN_IDS = [
  "introduction",
  "validMoves",
  "clockwiseSowing",
  "antiClockwiseSowing",
  "capturing",
  "kimbiKichwa",
  "mandatoryCapturing",
  "takataTurn",
  "gameEnding"
] as const;

export type HelpScreenId = (typeof HELP_SCREEN_IDS)[number];
